angular.module('jv.candidates.list.factory', ['ngStorage'])
.factory('jvCandidatesListFactory',['$timeout', 'jvCandidatesService', '$rootScope','$q', '$localStorage',
    function($timeout, jvCandidatesService,$rootScope,$q, $localStorage) {
        
        var candidateListFactory = function(){};
        candidateListFactory.prototype = {
            candidates : {
                list: [],
                subscribers: []
            },
            applications:{
                list:[],
                subscribers: []
            },
            totalCount : 0,
            GUID: 0,
            candidatesMap: {},
            applicationsMap:{},
            applicationIds:[],
            selectedCandidate: {
                'candidates':{},
                'applications':{}
            },
            selectedApplication: {},
            pageSize: 0,
            page: 0,
            currentPage: 0, //0 Index
            previousPage: 0,
            //resets selected candidate map when you uncheck select all 
            resetselectedCandidate: function(){
                this.selectedCandidate = {
                    'candidates':{},
                    'applications':{}
                };
                return this.selectedCandidate;
            },
            //update total count
            updateTotalCount: function(data){
                this.totalCount = data.totalCount;
            },
            updatePageSize: function(data){
                this.pageSize = data.maxResults || 10;
            },
            updateCurrentPage: function(currentPage) {
                this.previousPage = this.currentPage;
                this.currentPage = currentPage;
                this.updateApplicationIds(currentPage);
            },
            getCurrentPage: function() {
                return this.currentPage;
            },
            getPageSize: function(){
                return this.pageSize;
            },
            //update GUID
            updateGUID: function(data){
                this.GUID = data.candidateSearchId;
            },
            //returns a list of selected candidates.
            //@param attribute name for selected candidates is returned back if provided.
            getSelectedCandidates: function(attributeName){
                var list = [];
                var self = this;
                var map = 'candidatesMap';
                var entity = self.selectedCandidate.candidates;
                if(Object.keys(self.applicationsMap).length){
                    map = 'applicationsMap';
                    entity = self.selectedCandidate.applications;
                }
                angular.forEach(entity,function(isCandidateSelected,EId){
                    if(isCandidateSelected){
                        if(attributeName){
                            list.push(self[map][EId][attributeName]);
                        }else{
                            list.push(self[map][EId]);
                        }
                    }
                });
                return list;
            },
            //returns candidates map back with values for all candidates selected
            selectAllCandidates: function(){
                var self = this;
                var entity = 'candidates';
                if(Object.keys(self.applicationsMap).length){
                    entity = 'applications';
                }
                angular.forEach(self[entity]['list'],function(candidate,key){
                    self.selectedCandidate[entity][candidate.EId] = true;
                });
                return self.selectedCandidate;
            },
            //get list of candidates
            getCandidatesList: function(){
                return  this.candidates.list;
            },
            //get list of candidates
            getApplicationsList: function(){
                return  this.applications.list;
            },
            //create candidate map of candidate EIds to keep track of which ones are selected from the grid
            updateCandidatesMap : function(){
                var self = this;
                angular.forEach(self.candidates.list,function(candidate,key){
                    self.candidatesMap[candidate.EId] = candidate;
                });
            },
            //create candidate map of candidate EIds to keep track of which ones are selected from the grid
            updateApplicationsMap : function(){
                var self = this;
                angular.forEach(self.applications.list,function(application,key){
                    self.applicationsMap[application.EId] = application;
                });
            },
            updateApplicationIds : function(currentPage) {
                var self = this; 
                //If user is on the first page, then reset the localStorage and let it build the list. 
                if (angular.isUndefined($localStorage.applicationIds) || (self.currentPage == 0)) {
                    $localStorage.applicationIds = [];
                }
                var expectedApplicationIds = (self.currentPage+1)*self.pageSize;
                //If its the first page or next page, then add to the applicationIds list. 
                if ((self.currentPage == 0) || (self.currentPage >= self.previousPage && $localStorage.applicationIds.length < expectedApplicationIds)) {
                    angular.forEach(self.applications.list, function(application,key) {
                        $localStorage.applicationIds.push(application.EId);
                    })                    
                } else {
                    //On the previous page now, remove the last set of applicationIds
                    $localStorage.applicationIds.splice(expectedApplicationIds, (self.totalCount - ((self.currentPage+1)*self.pageSize)));
                }
            },
            getApplicationIds: function() {
                return $localStorage.applicationIds;
            },
            //get candidate map 
            getCandidatesMap: function(){
                return this.candidatesMap;
            },
            //get candidatess
            getCandidates: function(filterObj){
                var self = this;
                var deferred = $q.defer();
                var postData = angular.copy(filterObj);
                //do candidate search 
                jvCandidatesService.searchCandidates(postData,function(response){
                    if(response){
                        self.candidates.list = response.data.candidateSearchResults;
                        //fire callbacks for all registered subscribers
                        angular.forEach(self.candidates.subscribers,function(subscriber,index){
                            subscriber.call(self,response.data);
                        });
                        deferred.resolve(response);
                    }
                });
                return deferred.promise;
            },
            //get applications
            getApplications: function(filterObj){
                var self = this;
                var deferred = $q.defer();
                var postData = angular.copy(filterObj);
                //do candidate search 
                jvCandidatesService.searchApplications(postData,function(response){
                    if(response){
                        self.applications.list = response.data.applicationSearchResults;
                        //fire callbacks for all registered subscribers
                        angular.forEach(self.applications.subscribers,function(subscriber,index){
                            subscriber.call(self,response.data);
                        });
                        deferred.resolve(response);
                    }
                });
                return deferred.promise;
            },
            getApplicationsCount: function(filterObj, callback){
            	var postData = angular.copy(filterObj);
                //get candidate count
                jvCandidatesService.getApplicationsCount(postData, function(response){
                    callback(response.data);
                });                
            },
            registerCandidatesSubscribers : function(subscriberList){
                this.candidates.subscribers = this.candidates.subscribers.concat(subscriberList);
            },
            registerApplicationsSubscribers : function(subscriberList){
                this.applications.subscribers = this.applications.subscribers.concat(subscriberList);
            }
        };
        var FactoryObject = candidateListFactory.prototype;
        //register subscribers/callbacks that need to get fired when candidates on the grid change. 
        //Example of subscribers here are updateGUID, updateTotalCount,updateCandidatesMap
        FactoryObject.registerCandidatesSubscribers([FactoryObject.updateCandidatesMap,FactoryObject.updateGUID,FactoryObject.updateTotalCount,FactoryObject.updatePageSize]);

        FactoryObject.registerApplicationsSubscribers([FactoryObject.updateApplicationsMap,FactoryObject.updateGUID,FactoryObject.updateTotalCount,FactoryObject.updatePageSize]);
        return candidateListFactory;
    }
]);
